import { useMemo } from 'react';
import { required, length, regexp } from 'js/utils/Validation/validationRules';
import { IValidationMethodConfigLength, IValidationMethodConfigRequired, IValidationMethodConfigRegexp } from 'js/utils/Validation/types';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

export const useValidationConfig = () => {
    const translate = useComponentTranslations();

    return useMemo(() => ({
        personalId: [
            required({ error: 'playtech.mobile.system.bankIDAuth.personalID.empty' }) as IValidationMethodConfigRequired,
            regexp({
                re: /^[0-9]+$/,
                error: 'playtech.mobile.system.bankIDAuth.personalID.regexp'
            }) as IValidationMethodConfigRegexp,
            length({
                min: 10,
                max: 12,
                error: translate('playtech.mobile.system.bankIDAuth.personalID.length', [10, 12])
            }) as IValidationMethodConfigLength
        ]
    }), [translate]);
};
